export default __webpack_public_path__ + "static/media/mark-harrison.482f57fb.jpg";